import { useEffect, useRef } from 'react'
import { viewport, swipeBehavior } from '@telegram-apps/sdk-react'

/**
 * Hook for initializing Telegram viewport
 * Simply expands viewport to full height
 */
export function useTelegramViewport() {
  const viewportInitialized = useRef(false)

  useEffect(() => {
    const initTelegramViewport = async () => {
      if (!window.Telegram?.WebApp || viewportInitialized.current) return

      try {
        if (viewport.mount.isAvailable()) await viewport.mount()
        if (viewport.expand.isAvailable()) viewport.expand()
        if (swipeBehavior.mount.isAvailable()) await swipeBehavior.mount()

        viewportInitialized.current = true
      } catch (error) {
        console.error('[useTelegramViewport] Init error:', error)
      }
    }

    initTelegramViewport()
  }, [])
}
